import { render } from "./FieldColumnList.vue?vue&type=template&id=58c36738"
import script from "./FieldColumnList.vue?vue&type=script&lang=js"
export * from "./FieldColumnList.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__